import React from "react";

import { Menu, Header, Responsive } from "semantic-ui-react";

import BuildNumber from "../_buildNumber";

export default class FooterNav extends React.Component {
  state = {
    name: "--",
  };
  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
  };

  render() {
    return (
      <Responsive minWidth={768}>
        <Menu fixed={"bottom"} className={"footer-menu"} stackable>
          <Menu.Item>
            <Header as={"h6"} className={"subtle"}>
              Built by{" "}
              <a href={"https://sarstuff.co.uk"} rel="noopener noreferrer" target={"_blank"}>
                SarStuff
              </a>{" "}
              for{" "}
              <a href={"https://nsardakent.org.uk"} rel="noopener noreferrer" target={"_blank"}>
                NSARDA Kent
              </a>
            </Header>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <Header as={"h6"} className={"subtle"}>
                PAWS Version: v1.1 Build: #{BuildNumber}
              </Header>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Responsive>
    );
  }
}
